import * as v from "valibot";
import { ContestStatus, convertContestStatus } from "./contestStatus";
import {
  google,
  query_recursive_types as RpcRecursiveTypes,
} from "@/infra/api/rpc/api";

type ContestResponse = RpcRecursiveTypes.IContestResponse;

export const ContestListItemSchema = v.object({
  id: v.string(),
  status: v.enum(ContestStatus),
  name: v.string(),
  description: v.string(),
  discloseAt: v.optional(v.date()),
  openEntryAt: v.optional(v.date()),
  closeEntryAt: v.optional(v.date()),
  announceResultAt: v.optional(v.date()),
  thumbnailUrl: v.optional(v.string()),
});

export type IContestListItem = v.InferOutput<typeof ContestListItemSchema>;

// 時刻がnilの場合の値
const parseDate = (
  date: google.protobuf.ITimestamp | undefined | null,
): Date | undefined => {
  if (typeof date?.seconds !== "number" || date.seconds === 0) {
    return;
  }
  return new Date(date.seconds * 1000);
};

/**
 * @throws {v.ValiError}
 */
export const convertContestResponseToIContestListItem = (
  data: ContestResponse,
): IContestListItem => {
  return v.parse(ContestListItemSchema, {
    id: data.id?.value,
    status: convertContestStatus(data.status),
    name: data.name?.value ?? "",
    description: data.description?.value ?? "",
    discloseAt: parseDate(data.discloseAt),
    openEntryAt: parseDate(data.openEntryAt),
    closeEntryAt: parseDate(data.closeEntryAt),
    announceResultAt: parseDate(data.announceResultAt),
    thumbnailUrl: data.thumbnail?.servingUrl?.value ?? undefined,
  });
};

export const convertContestResponseToIContestListItemOrUndefined = (
  data: ContestResponse,
): IContestListItem | undefined => {
  try {
    return convertContestResponseToIContestListItem(data);
  } catch (error) {
    console.error("IContestListItem convert error:", error);
  }
};
